var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"target":"_blank","href":"https://store.steampowered.com/app/2273430"}},[_c('img',{attrs:{"id":"download-btn","src":require('../assets/images/download-'+ _vm.$i18n.locale +'.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }